<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        <slot name="title"></slot>
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>
      <slot name="icon"></slot>
      <user-info-label :user="item.user" />
    </div>
    <div v-if="!hideContent" class="os-history-item__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel.vue'

  export default {
    name: 'OrderStateHistoryItem',
    components: { UserInfoLabel },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      hideContent: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style lang="less" scoped>
  @import "./OrderStateHistoryItem.less";
</style>
